import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { CustomTextField } from '../../CustomComponents/CustomTextField';

export const RequestedShift = () => {
  const { control } = useFormContext();
  return (
    <Controller
      name="requestedShift"
      control={control}
      render={({ field }) => <CustomTextField {...field} label="Requested Shift" />}
    />
  );
};
